import { AccountResponse } from 'models/user';

export interface BaseEvent {
  MARKET_COUNTRY?: string;
  STORE_NAME?: string;
  STORE_TYPE?: string;
  VERTICAL_GROUP?: string;
  VERTICAL_SUB_GROUP?: string;
  USER_ID?: string;
  REWARD_LEVEL?: string;
  ISPRIME?: string;
  LEVEL?: string;
  COMPANY?: string;
  ROLE?: string;
  ERROR_MESSAGE?: string;
}
export interface SearchEvent extends BaseEvent {
  TRAVEL_PRODUCT_TYPE: 'HOTELS' | 'FLIGHTS' | 'BUS' | 'CAR_RENTAL';
  TRAVEL_FROM: string;
  TRAVEL_TO: string;
  TRAVEL_DESTINATION_TYPE: string;
  TRAVEL_TRIP_TYPE: string;
  TRAVEL_ADVANCED_PURCHASE: string;
  TRAVEL_DATE_FROM: string;
  TRAVEL_DATE_TO: string;
  TRAVEL_TRIP_LENGTH: string;
  TRAVEL_PASSENGERS: string;
  TRAVEL_ADULTS?: string;
  TRAVEL_CHILDREN?: string;
  TRAVEL_INFANTS?: string;
  TRAVEL_CLASS_OF_SERVICE?: string;
  TRAVEL_ROOMS?: string;
  TRAVEL_WITH_BAGGAGE?: string;
  TRAVEL_BRANCH_CODE: string;
  SEARCHID: string;
}

export interface ViewUpsellOptionsEvent extends SearchEvent {
  SOURCE: 'RESULTS';
  TRAVEL_PRODUCT_NAME: string; // airline
}
export interface SelectViewUpsellOptionsEvent extends ViewUpsellOptionsEvent {
  TRAVEL_ADVANCED_PURCHASE: 'FLEX';
}
export interface ViewTravelSearchScreenEvent extends BaseEvent {
  SOURCE: 'TRAVEL_HOME';
  TRAVEL_PRODUCT_TYPE: 'FLIGHTS' | 'HOTELS' | 'CAR_RENTAL';
}

export interface ViewTravelResultsScreenEvent extends SearchEvent {
  SOURCE: 'TRAVEL_HOME';
  RESULTS: number;
}

export interface SelectViewFiltersEvent extends SearchEvent {
  VIEW_TYPE: string;
}

export interface TravelErrorEvent extends ViewTravelResultsScreenEvent {
  ERROR_MESSAGE: string;
}

export enum FilterGroupEvent {
  STOPS = 'Stops',
  TRAVELPOLICIES = 'TravelPolicies',
  INCLUDEDTAXES = 'IncludedTaxes',
  PRICE = 'Price',
  AEROLINEA = 'Aerolinea',
  DEPARTURE_TIME = 'DepartureTime',
  ARRIVAL_TIME = 'ArrivalTime',
  ORDER = 'Order',
  STARS = 'Stars',
  HOTEL_NAME = 'HotelName',
  LOCATION = 'Location',
  AMENITIES = 'Amenities',
  SCORES = 'Scores',
  BOARDS = 'Boards',
  CHAINS = 'Chains',
  HOTEL_POLICIES = 'HotelPolicies',
  VEHICLE_CATEGORY = 'VehicleCategory',
  TRANSMISSION_TYPE = 'TransmissionType',
  MAX_PAX = 'MaxPax',
  DOORS = 'Doors',
  FUEL_TYPE = 'FuelType',
  AIR_CONDITIONED = 'AirConditioned',
  COMPANY = 'Company',
  MODEL = 'Model',
}
export interface SelectFilterEvent extends SearchEvent {
  FILTER_GROUP: FilterGroupEvent | '';
  FILTER_VALUE: string;
}

export interface ProductProps {
  TRAVEL_PRODUCT_CODE: string;
  TRAVEL_PRODUCT_NAME: string;
  TRAVEL_SUB_PRODUCT: string;
  TRAVEL_PRODUCT_CATEGORY: string;
  TRAVEL_PRODUCT_PRICE: string;
  TRAVEL_PRODUCT_PROVIDER: string;
  TRAVEL_FARE_TYPE: string;
}

export interface ViewTravelItemDetailEvent extends SearchEvent, ProductProps {
  SOURCE: 'LIST' | 'MAP';
  INDEX: number;
}

export interface AddToCartEvent extends SearchEvent, ProductProps {
  SOURCE: 'LIST' | 'MAP' | 'ITEM_DETAIL';
  INDEX: number;
}

export interface ViewTravelReservationEvent extends BaseEvent {
  SOURCE: 'MIS_VIAJES' | 'APROBACIONES' | 'MIS_VIAJES_HISTORICO';
}

export interface ViewTravelReservationDetailEvent extends BaseEvent {
  SOURCE: 'MIS_VIAJES' | 'APROBACIONES' | 'MIS_VIAJES_HISTORICO';
  ITINERARY_ID: number;
}

export type TravelEditPaxEvent = BaseEvent;

export interface ProceedToCheckoutEvent extends SearchEvent, ProductProps {
  SOURCE: 'BOOKING';
  ITINERARY_ID?: number;
}

export const amplitudelogEvent = (event: string, data: BaseEvent, userState: AccountResponse | null) => {
  //Props de Usuario
  // const userProperties = {
  //   ROLE: data.ROLE ?? (userState?.type === 'admin' ? 'ADMIN' : 'USUARIO'),
  //   LEVEL: data.ROLE ?? (userState?.type === 'admin' ? 'ADMIN' : 'USUARIO'),
  //   COMPANY: data.COMPANY ?? userState?.companyName ?? '',
  // };
  // // if (Amplitude.getInstance().options?.apiKey === undefined) {
  // //   Amplitude.getInstance().init(ENV.API_KEYS.AMPLITUDE_KEY);
  // //   Amplitude.getInstance().setUserProperties(userProperties);
  // // }
  // //Refuerza si los datos base no estan completos
  // data.MARKET_COUNTRY = data.MARKET_COUNTRY ?? userState?.country ?? '';
  // data.STORE_NAME = data.STORE_NAME ?? 'Corporate Travel';
  // data.STORE_TYPE = data.STORE_TYPE ?? 'Travel for Business';
  // data.VERTICAL_GROUP = data.VERTICAL_GROUP ?? 't4b';
  // data.VERTICAL_SUB_GROUP = data.VERTICAL_SUB_GROUP ?? 't4b';
  // //Refuerza si los datos de usuario no estan completos
  // data.USER_ID = data.USER_ID ?? userState?.idRappi ?? '';
  // data.REWARD_LEVEL = data.REWARD_LEVEL ?? '';
  // data.ISPRIME = data.ISPRIME ?? '';
  //125721 - al revés de quitar toda la lógica
  //Amplitude.getInstance().logEvent(event, data);
};
